import React from 'react';
import { Modal } from '../ui/Modal';
import { InquiryForm } from './InquiryForm';
interface InquiryModalProps {
  isOpen: boolean;
  onClose: () => void;
  preselectedProductId?: string;
}
export function InquiryModal({
  isOpen,
  onClose,
  preselectedProductId
}: InquiryModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Zatražite ponudu" maxWidth="lg" data-id="element-125">
      <InquiryForm preselectedProductId={preselectedProductId} onSuccess={onClose} data-id="element-126" />
    </Modal>;
}